import React, { Component } from 'react';
import * as styles from './loginStyles';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { FormInput } from '../../../common';
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Segment,
  Label
} from 'semantic-ui-react';
import { messages } from '../../../../utils';

const { validation } = messages;

class Login extends Component {
  onSubmitBtnClick(values) {
    const { handleSubmitBtn } = this.props;
    handleSubmitBtn(values);
  }
	render() {
    const { isLoading, onCreateAccount, onForgotPassword } = this.props;
		return (
      <div style={{ marginTop: '10px' }}>

  <Grid centered columns={2}>
    <Grid.Column>
      <Header as="h2" textAlign="center">
        Login
      </Header>
      <Segment>
        <Form size="large">
          <Formik
            initialValues={{ email: '', password: '' }}
            onSubmit={values => this.onSubmitBtnClick(values)}
            validationSchema={
              Yup.object().shape({
                email: Yup.string().email(validation.invalidEmail).max(100, "Maximum characters exceed 100").required(validation.requiredField),
                password: Yup.string().min(6, 'Password must be at least 6 characters').max(100, "Maximum characters exceed 100").required(validation.requiredField),
              })
            }
            render={({
              values,
              handleSubmit,
              setFieldValue,
              errors,
              touched,
            }) => (
              <div>
                <div className="row">
                  <div className="col-sm">
                  {errors.email && touched.email && <Label>
                      {errors.email}
                    </Label>}
                     <FormInput
                     style={{marginBottom:'10px'}}
                     value={values.email}
                     fluid
                      icon="user"
                      iconPosition="left"
                      placeholder="Email address"
                     onChange={(event ,data) => data && data.name ? setFieldValue(data.name, data.value): ''}
                      required
                      name='email'
                      type='text'
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm mt-4">
                  {errors.password && touched.password && <Label style={{marginTop:'5px'}}>
                      {errors.password}
                    </Label>}
                  <FormInput
                  style={{marginBottom:'10px'}}
                    fluid
                    value={values.password}
                    icon="lock"
                    iconPosition="left"
                    placeholder="Password"
                    type="password"
                    name="password"
                    onChange={(event ,data) => data && data.name ? setFieldValue(data.name, data.value): ''}
                    required
                  />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm text-left">
                    <a href="#" onClick={onForgotPassword}>Forgot Password?</a>
                  </div>
                  <div className="col-sm text-right" style={styles.forgetBtnStyle}>
                  <Button loading={isLoading} color="blue" type="submit" fluid size="large" onClick={() => handleSubmit(values)}>Login</Button>
                  </div>
                </div>
              </div>
            )}
          />
        </Form>
      </Segment>
      <Message>
        Not registered yet? <a  href="#" onClick={onCreateAccount}>Sign Up</a>
      </Message>
    </Grid.Column>
       </Grid>
      </div>
		);
	}
}

export default Login;